import React from 'react';

import PageComponents from './CommonPageComponents';

const NetworkComponents: React.FC = () => {

  return (
    <PageComponents
      iconText="📡"
      titleText="Network Error"
      msgText="Oops! You are offline. Please check your internet connection."
      buttonText="Go Retry"
      buttonLink="/"
      onClick={() => window.location.reload()}
    />
  );
};

export default NetworkComponents;
